import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AddCron, UpdateCron } from './cron.interface';

@Injectable({
    providedIn: 'root',
})
export class CronService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.administrative.crons.list;

    private listActiveUrl = this.basePath + environment.interop.indoc.nomenclatoare.administrative.crons.listActive;

    public listDTUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.administrative.crons.listDT;

    private storeURL =
        this.basePath +
        environment.interop.indoc.nomenclatoare.administrative.crons.store;

    private updateUrl = this.basePath + environment.interop.indoc.nomenclatoare.administrative.crons.update;

    private deleteUrl = this.basePath + environment.interop.indoc.nomenclatoare.administrative.crons.delete;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.administrative.crons.updateStatus;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getList() {
        return this.http.get(this.listUrl, this.httpOptions);
    }

    getListActive() {
        return this.http.get(this.listActiveUrl, this.httpOptions);
    }

    storeEntry(payload: AddCron) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateCrons(cron: UpdateCron) {
        return this.http.put(this.updateUrl, cron, this.httpOptions);
    }

    deleteCrons(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
